// extracted by mini-css-extract-plugin
export var commentsSection = "comments-section-module--comments-section--+zkOa";
export var commentsSectionTitle = "comments-section-module--comments-section-title--5q7BF";